import { motion } from "framer-motion";

const CHAPTERS = [
    {
        n: "01",
        eyebrow: "The Shift",
        title: "Regulation is no longer disclosure. It is consequence.",
        body: "For a decade, climate reporting was a communications exercise. That era has ended. Central banks, exchanges, and border authorities are converting emissions into cost — through supervisory ratios, disclosure mandates, and carbon border tariffs."
    },
    {
        n: "02",
        eyebrow: "The Exposure",
        title: "Carbon is now a credit, pricing, and compliance risk.",
        body: "For MSMEs, it is the difference between winning and losing an export order. For banks, it is a lever on the cost of capital and portfolio provisioning. For large buyers, it is a supplier‑risk problem measured in millions."
    },
    {
        n: "03",
        eyebrow: "The Response",
        title: "The tools that price this risk did not exist. So we built them.",
        body: "Carbonis is climate risk infrastructure — an operating layer that converts carbon data into decisions. Identify, quantify, mitigate, protect. Built for MSME realities. Aligned with the frameworks lenders and regulators actually enforce."
    }
];

export default function Manifesto() {
    return (
        <section className="relative py-32 lg:py-44" data-testid="manifesto-section">
            <div className="max-w-[1500px] mx-auto px-6 lg:px-10">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-100px" }}
                    transition={{ duration: 0.8 }}
                    className="flex items-center gap-4 mb-24"
                >
                    <div className="w-10 h-px bg-gold"></div>
                    <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-gold">Manifesto — Three Chapters</span>
                </motion.div>

                <div className="flex flex-col gap-20 lg:gap-32">
                    {CHAPTERS.map((c, i) => (
                        <motion.article
                            key={c.n}
                            initial={{ opacity: 0, y: 60 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-120px" }}
                            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
                            className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-start"
                            data-testid={`manifesto-chapter-${c.n}`}
                        >
                            <div className="lg:col-span-4 flex flex-col gap-3">
                                <span className="chapter-num text-[120px] md:text-[160px] lg:text-[200px] text-gold/90">{c.n}</span>
                                <span className="font-mono text-[11px] tracking-[0.28em] uppercase text-navy/50">— {c.eyebrow}</span>
                            </div>
                            <div className="lg:col-span-8 lg:pt-6">
                                <h3 className="font-serif text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-[-0.02em] text-navy">
                                    {c.title}
                                </h3>
                                <p className="mt-8 max-w-[600px] text-navy/60 text-base lg:text-lg leading-relaxed">
                                    {c.body}
                                </p>
                            </div>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
